// ============================================================================
// cattle.herds.detail — migrated off the global read
// ============================================================================
// The animal record mounted for a non-empty /cattle/herds/ suffix. Separate from the hub so a record URL does not pay the hub read.
//
// ONE FILE PER MIGRATED SURFACE, deliberately. This used to be one entry in a
// central MIGRATED map inside surfaceDataManifest.ts, which meant every
// concurrent localization edited the same object and collided. Discovery is now
// an eager glob over this directory, so two surfaces migrating at once touch
// two different files.
//
// The one-owner rule still holds and is still what makes a half-migrated state
// unrepresentable: this declaration REPLACES legacy.all for its surface rather
// than joining it. The physical reads it displaced must move to `retired` in
// render-read-sites.json in the same change, and
// tests/fixtures/migrated-surface-receipts/cattle.herds.detail.json is the independent
// historical record that this pair existed — so deleting both this file and the
// catalog resource together still fails.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'cattle.herds.detail',
  obligations: Object.freeze([Object.freeze({id: 'cattle.animal.detail', owner: 'permanent'})]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
